import type { BaseQueryFn, FetchArgs } from '@reduxjs/toolkit/query';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import cookies from 'js-cookie';

import { env } from '@/utils/env';

import type { ApiError } from './api-error';
import { normalizeApiError } from './api-error';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: env.BASE_URL,
  credentials: 'include',
  prepareHeaders: (headers) => {
    const accessToken = cookies.get('access_token');
    if (accessToken) {
      headers.set('Authorization', `Bearer ${accessToken}`);
    }

    return headers;
  },
});

export const apiBaseQuery: BaseQueryFn<string | FetchArgs, unknown, ApiError> = async (
  args,
  api,
  extraOptions,
) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error) {
    return {
      error: normalizeApiError(result.error),
      meta: result.meta,
    };
  }

  return result;
};
